<template>
<div v-if="isPageVisible">
    <div class="header">
      <div class="search">
        <img class="search-icon" src="@/assets/search.png" />
        <input v-model="inputValue" v-on:input="onSearchInput($event.target.value,$event)" v-on:focus="clearTips" maxlength="127" placeholder="请输入品牌、机型" />
        <img v-on:click="closeSearch()" class="close" v-if="searching" src="@/assets/close.png" />
      </div>
    </div>
    <div class="result-list" v-if="searching" style="overflow-y: scroll;">
        <div v-for="(item, index) in searchList" :key="index" :data-index="index" data-type="search" @click="onSelectPhoneModel(index, 'search')">
        {{ item.name }}
        </div>
    </div>

    <div class="selection">
        <div class="nav-wrapper">
        <div class="nav" ref="navScroll">
            <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['nav-item', index === currNav ? 'active' : '']"
            @click="onSwitchNav(null,index)"
            ref="navItems"
            >
            {{ item.name }}
            <div class="nav-item-target" :id="'text' + index"></div>
            </div>
        </div>
        </div>

        <div class="wrapper">
        <div class="bar" ref="barScroll">
            <div
            v-for="(item, index) in brandList"
            :key="index"
            :class="['bar-item', index === currBrand ? 'active' : '']"
            @click="onChangeTab(null,index)"
            >
            {{ item.name }}
            </div>
        </div>

        <div class="content" ref="contentScroll">
            <div v-for="(item, index) in productList" :key="index" class="content-item" :data-index="index" data-type="product" @click="onSelectPhoneModel(index, 'product')">
            <div class="content-item-name">{{ item.name }}</div>
            </div>
            <div class="data-load" v-if="!productList.length">加载中</div>
        </div>
        </div>
    </div>
</div>
<div v-else>
    <p>channelId错误</p>
  </div>
</template>
<script>
export default {
  components: {  },
    data(){
        return{
            navList: [],
            currNav: 0, //分类的索引
            brandList: [],
            currBrand: 0, //左侧的bar的索引
            productList: [],
            searching: false,
            searchList: [],
            type: 0, //区分快速估价还是快速审单
            categoryId:'',
            brandId:'',
            inputValue:"",
            channelId:"",
            isPageVisible:true,
        }
    },

    async created() {
        this.$nextTick(async () => {
        this.type = this.$route.query.type;
        this.channelId = this.$route.query.channelId; 
        this.checkChannelId();
        try {
            // 渲染分类导航
            this.$api.getLinkagePhoneModel({
                })
                .then((res) => {
                this.result = res.data || [];

                this.navList = this.result.map((item) => ({
                    name: item.name,
                    id: item.id,
                    }));
                this.onSwitchNav(null,0);

            });


        } catch (error) {
            console.error("Error fetching data:", error);
        }

    });
  },

    methods: {
        clearTips: function(e) {
            this.searching = true;
        },
        checkChannelId() {
            if (this.channelId) {

                this.$api.checkChannelId({
                    channelId: this.$route.query.channelId,
                }).then((res) => {
                    let userId = res.data;
                    if(userId != null && userId != 0){
                        this.isPageVisible = true;
                    }else{
                        this.isPageVisible = false;
                    }

                });

            } else {
                this.isPageVisible = false;
            }


        },
        onSearchInput(value,event) {
          clearTimeout(this.timer);

        
          if (!value) {
            this.searchList = [];
            return;
          }
          this.timer = setTimeout(() => {
            this.fetchSearchResult(value);
          }, 1000);
        },
        async fetchSearchResult(value) {
          try {
            // const result = await this.$http.get('hjx/category', {
            //   params: {
            //     page: 0,
            //     size: -1,
            //     nameLike: value,
            //     typeKey: 'phoneModal'
            //   }
            // });
            this.$api.getSearchPriceH5Class({
                    typeKey: "phoneModal",
                    status: 1,
                    page: 0,
                    size: -1,
                    nameLike: value,
                    channelId:this.$route.query.channelId,
                })
                .then((res) => {
                const records = res.data.records || [];

                const searchList = records.map(item => {
                const { name, id, ycy, face, disableQuotes, model, memoryHourglass, backboard, chargingPort, brandName, brandId, categoryId } = item;
                return {
                    name,
                    id,
                    ycy,
                    face,
                    disableQuotes,
                    model,
                    memoryHourglass,
                    backboard,
                    chargingPort,
                    brandName,
                    brandId,
                    categoryId
                };
                });
        
                this.searchList = searchList;
                });
            
          } catch (error) {
            console.error('Error fetching search result:', error);
          }
        },
        onSelectPhoneModel(index, type) {
            
            let item;
            if(type == "search"){
                item = this.searchList[index]
            }else if(type == "product"){
                item = this.productList[index]       
            }
            
            const { name, id, ycy, face, disableQuotes, model, memoryHourglass, backboard, chargingPort, brandName, brandId, categoryId } = item

            let curBrandName = brandName
            let curBrandId = brandId
            let curCategoryId = categoryId

            if (brandName === undefined) {
                curBrandName = this.brandList[this.currBrand].name
            }
            if (brandId === undefined) {
                curBrandId = this.brandId
            }
            if (categoryId === undefined) {
                curCategoryId = this.categoryId
            }

            this.$app.model = {
                name,
                id,
                ycy,
                face,
                model,
                memoryHourglass,
                backboard,
                chargingPort,
                brandName: curBrandName,
                disableQuotes,
                brandId: curBrandId,
                categoryId: curCategoryId
            }

            let url = '/modelValuation?channelId=' + this.$route.query.channelId; 
            
            // 使用Vue Router进行页面导航
            this.$router.push(url)
        },
        closeSearch() {
            this.inputValue = "";
            this.searching = false;
            this.searchList = [];
        },
        onSwitchNav(e, index) {
            if (e) {
                index = e.currentTarget.dataset.index;
            }

            const brandList = this.getBrandListByIndex(index);
            this.currNav = index;
            this.brandList = brandList;
            this.categoryId = this.navList[index].id;

            this.onChangeTab(null, 0);
        },
        getBrandListByIndex(navIndex) {
            try {
                if (!this.brandCache) this.brandCache = {};
                if (this.brandCache[navIndex]) return this.brandCache[navIndex];

                const result = this.result;
                const category = result[navIndex].children;
                const brandList = category.map((item) => {
                return {
                    name: item.name,
                    id: item.id,
                };
                });

                this.brandCache[navIndex] = brandList;

                return brandList;
            } catch (err) {
                return [];
            }
        },
        onChangeTab(e, index) {
            clearTimeout(this.renderTimer);

            if (e) {
                index = e.currentTarget.dataset.index;
            }
            this.currBrand = index;
            this.productList = [];
            this.brandId = this.brandList[index].id;

            const allList = this.getProductListByIndex(this.currNav, index);

            let step = 50;
            let start = 0;
            const render = () => {
            let list = allList.slice(start, start + step);
            this.productList = this.productList.concat(list);
            this.$nextTick(() => {
                this.renderTimer = setTimeout(() => {
                start += step;
                if (start < allList.length) {
                    render();
                }
                }, 50);
            });
            };
            render();
        },
        getProductListByIndex(navIndex, brandIndex) {
            try {
            if (!this.productCache) {
                this.productCache = {};
            }
            if (!this.productCache[navIndex]) {
                this.productCache[navIndex] = {};
            }
            if (this.productCache[navIndex][brandIndex]) {
                return this.productCache[navIndex][brandIndex];
            }

            const result = this.result;
            const brandList = result[navIndex].children;
            const brand = brandList[brandIndex].children;
            const productList = brand.map(item => {
                const { name, id, ycy, face, disableQuotes, model, memoryHourglass, backboard, chargingPort } = item;
                return {
                    name,
                    id,
                    ycy,
                    face,
                    disableQuotes,
                    model,
                    memoryHourglass,
                    backboard,
                    chargingPort
                };
            });

            this.productCache[navIndex][brandIndex] = productList;

            return productList;
            } catch (err) {
            console.error(err);
            return [];
            }
        },
    }

}

</script>
<style lang="less" scoped>

.page {
background-color: #fff;
height: 100%;
overflow: hidden;
}

.header {
padding: 1rem 1.3333rem;
height: 4.3333rem;
box-sizing: border-box;
}

.search {
border-radius: 1rem;
height: 2.3333rem;
background-color: #f7f7f7;
display: flex;
align-items: center;
}

.search .search-icon {
margin-left: 1rem;
width: 1rem;
height: 1.0667rem;
margin-right: 1rem;
}

.search .close {
width: 1.6667rem;
height: 1.6667rem;
}

.search input {
    width: 17.3333rem;
    color: #999;
    padding-top: 0.2rem;
    cursor: auto;
    display: block;
    height: 1.2rem;
    text-overflow: clip;
    overflow: hidden;
    white-space: nowrap;
    font-family: UICTFontTextStyleBody;
    min-height: 0.6rem;
    border: none;
    outline: none;
    background-color: inherit;
}

.result-list {
padding: 0 1.3333rem;
z-index: 9;
background-color: #fff;
position: fixed;
top: 4.3333rem;
width: 100%;
height: calc(100vh - 4.3333rem);
box-sizing: border-box;
}

.result-list div {
font-size: 1rem;
padding: 0.6667rem 0 0.6667rem 2.8rem;
}

.result-list div:last-child {
padding-bottom: 0.6667rem;
padding-bottom: calc(0.6667rem + constant(safe-area-inset-bottom));
padding-bottom: calc(0.6667rem + env(safe-area-inset-bottom));
}

.nav {
margin: 0 auto;
display: flex;
border-bottom: 0.0333rem #e1e1e1 solid;
height: 2.3333rem;
box-sizing: border-box;
}

.nav-item {
width: 8.3333rem;
flex-shrink: 0;
height: 100%;
line-height: 1.3333rem;
font-size: 0.9333rem;
text-align: center;
position: relative;
}

.nav .active {
color: #3871fe;
font-weight: bold;
font-size: 1rem;
}

.nav-item-target {
position: absolute;
width: 100%;
height: 100%;
top: 0;
left: -8.3333rem;
z-index: -1;
}

.wrapper {
display: flex;
height: calc(100vh - 6.6667rem);
}

.bar {
width: 5.3333rem;
background-color: #f7f7f7;
}

.bar-item {
display: flex;
align-items: center;
justify-content: center;
color: #999;
min-height: 3.3333rem;
font-size: 0.9333rem;
text-align: center;
word-wrap: break-word;
word-break: break-all;
box-sizing: border-box;
padding: 0.6667rem 0;
}

.bar .active {
color: #366ffe;
background-color: #fff;
position: relative;
font-weight: bold;
}

/* .bar .active:after {
position: absolute;
width: 0.2rem;
left: 0.8667rem;
top: 50%;
margin-top: -0.75rem;
background-color: #366ffe;
height: 1.5rem;
content: "";
} */

.content {
width: 19.6667rem;
}

.content-item {
float: left;
margin-bottom: 1.4333rem;
margin-left: 1.4333rem;
width: 7.6667rem;
height: 2.6667rem;
padding: 0.6667rem;
background-color: #f7f7f7;
display: flex;
align-items: center;
justify-content: center;
}

.content-item:nth-child(1),
.content-item:nth-child(2) {
margin-top: 1.4333rem;
}

.content-item-name {
font-size: 0.7333rem;
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
text-align: center;
}

.data-load{
    padding-top:1rem;
    padding-left:1rem;
}

::-webkit-scrollbar {
width: 0;
height: 0;
color: transparent;
}





</style>